import { Grid2 as Grid, Stack, Typography, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import LoginIcon from "@assets/login-icon.svg?react";
import ParkingIcon from "@assets/parking-icon.svg?react";
import Logo from "@assets/pshva-logo.svg?react";
import VehicleIcon from "@assets/vehicle-icon.svg?react";
import { emailAuth } from "@utils/emailAuthUtils.ts";

const flowGridContainerSize = {
  xs: 12,
  md: 4,
};

export default function HomeRoot() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isEntraAuthenticated = useIsAuthenticated();
  const isEmailAuthenticated = !emailAuth.isTokenExpired();
  const isAuthenticated = isEntraAuthenticated || isEmailAuthenticated;

  const handlePurchaseClick = () => {
    if (isAuthenticated) {
      void navigate("/purchase");
    }
  };

  const handleUserDetailsClick = () => {
    if (isAuthenticated) {
      void navigate("/user");
    }
  };

  return (
    <Stack
      padding={4}
      spacing={4}
      justifyItems="center"
      justifyContent="center"
      alignItems="center"
    >
      <Logo title={t("wellbeingServicesCounty")} />
      <Typography variant="h3" component="h1" textAlign="center">
        {t("home.title")}
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        {!isAuthenticated && (
          <Grid size={flowGridContainerSize} container>
            <Box
              sx={{
                width: "100%",
                padding: 2,
                borderRadius: 1,
              }}
            >
              <Grid container>
                <Grid size={2}>
                  <LoginIcon aria-hidden />
                </Grid>
                <Grid size={10}>
                  <Typography variant="h6">
                    {t("home.flow.login.title")}
                  </Typography>
                  <Typography variant="subtitle1" color="textSecondary">
                    {t("home.flow.login.description")}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        )}
        <Grid size={flowGridContainerSize} container>
          <Box
            sx={{
              width: "100%",
              padding: 2,
              borderRadius: 1,
              height: { xs: "auto", md: "220px" },
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid size={2}>
                <ParkingIcon aria-hidden />
              </Grid>
              <Grid size={10}>
                <Typography variant="h6">
                  {t("home.flow.buyParkingPermit.title")}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {t("home.flow.buyParkingPermit.description")}
                </Typography>
              </Grid>
            </Grid>
            {isAuthenticated && (
              <Grid container sx={{ marginTop: { xs: 2, md: "auto" } }}>
                <Grid size={2}>
                  {/* Empty space to align with icon above */}
                </Grid>
                <Grid size={10}>
                  <Button
                    variant="contained"
                    onClick={handlePurchaseClick}
                    sx={{
                      width: "fit-content",
                    }}
                  >
                    Osta &gt;
                  </Button>
                </Grid>
              </Grid>
            )}
          </Box>
        </Grid>
        <Grid size={flowGridContainerSize} container>
          <Box
            sx={{
              width: "100%",
              padding: 2,
              borderRadius: 1,
              height: { xs: "auto", md: "220px" },
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid size={2}>
                <VehicleIcon aria-hidden />
              </Grid>
              <Grid size={10}>
                <Typography variant="h6">
                  {t("home.flow.manageVehicles.title")}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {t("home.flow.manageVehicles.description")}
                </Typography>
              </Grid>
            </Grid>
            {isAuthenticated && (
              <Grid container sx={{ marginTop: { xs: 2, md: "auto" } }}>
                <Grid size={2}>
                  {/* Empty space to align with icon above */}
                </Grid>
                <Grid size={10}>
                  <Button
                    variant="contained"
                    onClick={handleUserDetailsClick}
                    sx={{
                      width: "fit-content",
                    }}
                  >
                    Hallinnoi &gt;
                  </Button>
                </Grid>
              </Grid>
            )}
          </Box>
        </Grid>
      </Grid>
      <Outlet />
    </Stack>
  );
}
